import Debug from 'debug'
const debug = Debug('babel-register-module')

export default function(patterns, opts = {}) {
  patterns = patterns || []
  opts = {silent: false, ...opts}
  require('babel-register')({
    ignore: function(filename) {
      function ret(shouldIgnore) {
        shouldIgnore ? debug('transpile nup:', filename) : debug('transpile yep:', filename)
        return shouldIgnore
      }
      // Check if file is in package user wants us to transpile.
      // E.g. An npm linked package or one we manually patched in `node_modules`.
      if (shouldTranspile(filename, patterns)) return ret(false)
      // Otherwise, ignore everything in node_modules.
      if (isInsideNodeModules(filename)) return ret(true)
      // Transpile the rest.
      return ret(false)
    },
  })
  require('require-module-main').default({patterns, silent: opts.silent})
}

function isInsideNodeModules(filename) {
  return filename.indexOf('node_modules') !== -1
}

function shouldTranspile(filename, patterns) {
  return patterns.some(str => {
    return filename.indexOf(str) !== -1
  })
}
